import { InjectionToken } from '@angular/core';
import { environment } from '@environment';

/**
 * Whether the wordmark opens the product menu at all (owner's decision on GAL-59 [Q11]).
 *
 * The ONE predicate for every shell: the menu exists once the Galleries host is up, and that host is
 * known the way every sibling surface is — by its address in the environment. Empty on prod today,
 * so the live photographers of Фотокласс and Фотобук keep the plain wordmark link (FKS-12732);
 * filling `GALLERY_APP_URL` turns the menu on everywhere without a shell change.
 * Not «any sibling with an address»: Фотокласс always has one, and Фотобук would grow a menu on prod.
 */
export const PRODUCT_MENU_ENABLED = new InjectionToken<boolean>('PRODUCT_MENU_ENABLED', {
  providedIn: 'root',
  factory: () => environment.GALLERY_APP_URL !== '',
});
